import React from 'react';

// enter key events were being sent to the first registered event handler, which would be the parent window in nested popup windows
// instead they need to go FIFO through the callbacks, so this is a middleware object to get callbacks for an event and call them
// in reverse letting each call determine if it should continue or not
export default class PopupWindowKeypressEventHandlerManager {
	constructor() {
		// the callbacks for when a key is pressed, insert to the front of this array
		this.callbacks = [];

		// each listener needs to be able to identify itself, so register for an ID (React doesn't have a reliable "future-proof" unique ID)
		this.listenerCount = 0;

		// register/unregister has to use THE SAME FUNCTION
		// since using bind then need to use the BIND function and not the original one or else listeners won't be removed
		this.keyPressedBound = this.keyPressed.bind(this);
	}

	registerListener(callback) {
		return ++this.listenerCount;
	}

	// don't use this directly, use keyPressedBound instead
	keyPressed(e) {
		switch (e.keyCode) {
			case 27:
			case 13:
				e.stopPropagation();
				e.preventDefault();
				// go through callbacks
				this.callbacks.reduce((allowNext, callback) => {
					return allowNext && callback.callback(e);
				}, true);
				break;

			default:
				// let key continue
				break;

		}
	}

	// start listening for enter/cancel keys
	addEventCallback(listenerId, callback) {
		this.checkValidListenerId(listenerId);

		const callbackIndex = this.callbacks.findIndex(callback => callback.id === listenerId);
		if (callbackIndex !== -1) {
			throw new Exception("listener already has a callback. can only have one callback per listener at a time", arguments);
		}

		// check if this is the first event to be registered
		if (this.callbacks.length === 0) {
			document.addEventListener("keydown", this.keyPressedBound);
		}

		// add callback
		this.callbacks.unshift({id: listenerId, callback: callback});

	}

	checkValidListenerId(listenerId) {
		if (listenerId > this.listenerCount || !listenerId) {
			throw new Exception("Every event callback must have a registered listener, call registerListener() to get an id", arguments);
		}
	}

	// stop listening for enter/cancel keys
	removeEventCallback(listenerId) {
		this.checkValidListenerId(listenerId);

		const callbackIndex = this.callbacks.findIndex(callback => callback.id === listenerId);
		this.callbacks.splice(callbackIndex, 1);

		// not listening anymore so remove listener
		if (!this.callbacks.length) {
			document.removeEventListener('keydown', this.keyPressedBound);
		}
	}
}
